export function isApiEnv() {
  return !(typeof window != 'undefined' && window.document);
}
